// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";

Vue.config.productionTip = false;
Vue.use(ElementUI);

axios.interceptors.request.use(
  function(response) {
    // 对请求参数进行处理
    if (response.params) {
      // 去除空值或 undefined 的参数
      Object.keys(response.params).forEach((key) => {
        if (response.params[key] === '' || response.params[key] === undefined) {
          delete response.params[key];
        }
      });
    }
    if (sessionStorage.getItem("accessToken")) {
      response.headers.common["Authorization"] =
        "Bearer " + sessionStorage.getItem("accessToken");
    }
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          sessionStorage.removeItem("accessToken");
          ElementUI.Message.warning("请先登陆");
          router.push("/login");
      }
    }
    return Promise.reject(error);
  }
);

Vue.prototype.$ajax = axios;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});
